import {useEffect, useState} from 'react';
import {PATH} from 'constants/common';
import {useCheckResetPasswordHash} from 'api/users';
import {useGetAuthFactors, useGetPasswordResetTwoFA} from 'api/futurae';
import Loader from 'components/ui/AmnisLoader/AmnisLoader';
import ResetPassword from 'components/ui/ResetPassword/ResetPassword';
import VerifyError from 'components/ui/Errors/VerifyError';
import {useAuth} from '../../../context/auth-context';

const COMPONENT_2FA = '2fa';
const COMPONENT_PW_FORM = 'pw_form';

const ResetPasswordPage = (props: any) => {
    const {setToken} = useAuth();
    const {
        history,
        match: {
            params: {hash},
        },
    } = props;

    const [showComponent, setShowComponent] = useState<string | null>(null);
    const [authToken, setAuthToken] = useState<string | null>(null);

    const {
        data: checkHashData,
        isError: isErrorHash,
        isLoading: isLoadingHash,
    } = useCheckResetPasswordHash(hash);

    const {
        data: getFactorsData,
        isError: isErrorGetFactors,
        isSuccess: isSuccessGetFactors,
        isLoading: isLoadingGetFactors,
    } = useGetAuthFactors(checkHashData?.token);

    const {mutate: triggerPasswordResetTwoFA} = useGetPasswordResetTwoFA();

    // check what kind of 2fa is set for the user
    useEffect(() => {
        if (!isSuccessGetFactors || !checkHashData) {
            return;
        }

        if (!getFactorsData.factors || getFactorsData.factors.length === 0) {
            // user has no 2fa set up
            setAuthToken(checkHashData?.token || null);
            setShowComponent(COMPONENT_PW_FORM);
        } else {
            setToken(checkHashData?.token || null);
            triggerPasswordResetTwoFA(
                {token: checkHashData?.token},
                {
                    onSuccess: ({token}) => {
                        setShowComponent(COMPONENT_PW_FORM);
                        if (token) {
                            setAuthToken(token);
                        } else {
                            setAuthToken(checkHashData?.token);
                        }
                    },
                    onError: () => history.push(PATH.FORGOT_PASSWORD),
                },
            );
        }
    }, [isSuccessGetFactors, getFactorsData, checkHashData, setToken]);

    if (isLoadingHash || isLoadingGetFactors) {
        return <Loader />;
    }

    if (isErrorHash || isErrorGetFactors) {
        return (
            <VerifyError
                title={
                    isErrorHash
                        ? 'The link is invalid.'
                        : 'Your account verification FAILED.'
                }
                text="Please try to reset your password again."
                onClick={() => history.push(PATH.FORGOT_PASSWORD)}
                btnTitle="Reset Password"
            />
        );
    }

    if (showComponent === COMPONENT_PW_FORM && authToken) {
        return <ResetPassword token={authToken} />;
    }

    return <Loader />;
};

export default ResetPasswordPage;
